// import Swiper from "swiper"
import { qq, q } from "../../helper/q"
import { Swiper, Navigation } from "swiper/dist/js/swiper.esm.js"
import { EventObserver } from "../../helper/eventObserver"
import { beviale } from "./slides/beviale"

Swiper.use([Navigation])

let sliders = []
export const mainSliderObserver = new EventObserver()

export const mainSliderInit = () => {
  const sliderElement = q(".mainSlider")
  if (sliderElement) {
    const mainSlider = new Swiper(sliderElement, {
      slidesPerView: "1",
      loop: false,
      init: false,
      navigation: {
        prevEl: q(".mainSliderButtonPrev"),
        nextEl: q(".mainSliderButtonNext")
      }
    })
    mainSlider.init()

    mainSlider.on("slideChange", () => {
      mainSliderObserver.broadcast({
        active: mainSlider.slides[mainSlider.activeIndex].querySelector("div")
      })
    })

    beviale(mainSlider.slides[mainSlider.activeIndex].querySelector("div"))
  }
}
